<template>
  <div class="view-tasklists account-lookup">
    <user-menu />
    <div class="wrapper">
      <masteradmin-sidebar-menu v-if="masterAdmin == true" />
      <researcher-sidebar-menu v-if="researcher == true" />
      <CSRSidebarMenu v-if="csr == true" />
      <div class="content-wrapper">
      <div class="container-wrapper center" >

        <div class="col-12 override-padding">
          <div class="col-8 override-padding float-left">
          <h3 class="d-inline heading">
            Account Report
          </h3>
          </div>
          <div class="col-4 override-padding float-right text-align-right">
            <router-link to="/report-dashboard">
            <button class="btn btn-red btn-md input-height-15 report-dashboard-link"><i class="fa fa-chevron-left" aria-hidden="true" style="padding-right: 10px;"></i> Back to Reporting Dashboard</button>
            </router-link>
          </div>
          <div style="clear: both"></div>
        </div>
        <div class="heading-seperator"></div>
        <div style="clear: both; float: none;" class="col-12 margin-bottom-10"></div>

        <AccountReportFilter
        ref="AccountReportFilter"
        :type="type"
        >

        </AccountReportFilter>

          <div style="clear: both; float: none;" class="col-12"></div>              
        <div class="org_details" style="margin-top: 30px;">

          <div class="handle2 float-left col-lg-12 override-padding collapse-wrapper float-right" style="padding-top: 2px;" >
          <b-link v-b-toggle="'display-columns'" >
            <div>
              SELECT DISPLAY COLUMNS YOU WANT IN REPORT
              <i class="fa fa-angle-down" aria-hidden="true"></i>
            </div>
          </b-link>
          </div>
          <b-collapse v-bind:id="'display-columns'" class="mt-2" visible >
          <div class="border-content float-left col-12 override-padding" style="padding-bottom: 30px;">

            <div class="col-md-6 float-left override-padding">
              <div class="col-12">
                <div class="display_column_heading">ORGANIZATION</div>
                <div class="display_column_fields">
                  <div class="col-6 float-left" style="padding-top: 0px;" >
                    <div v-for="(field, index) in org_display_fields">
                      <div v-if="index <=14">
                      <input
                        type="checkbox"
                        v-bind:id="'org_' + index"
                        v-bind:name="'org[' + index + ']'"
                        ref="is_enabled"
                        v-model="field.checked"
                        />
                      <label
                      class="">{{ field.text }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 float-left" style="padding-top: 0px;" >
                    <div v-for="(field, index) in org_display_fields">
                      <div  v-if="index > 14">
                      <input
                        type="checkbox"
                        v-bind:id="'org_' + index"
                        v-bind:name="'org[' + index + ']'"
                        ref="is_enabled"
                        v-model="field.checked"
                        />
                      <label
                      class="">{{ field.text }}</label>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>

            <div class="col-md-6 float-left override-padding">
              <div class="col-12">
                <div class="display_column_heading">INDIVIDUALS</div>
                <div class="display_column_fields">
                  <div class="col-6 float-left" style="padding-top: 0px;" >
                    <div v-for="(field, index) in ind_display_fields">
                      <div v-if="index <=14">
                      <input
                        type="checkbox"
                        v-bind:id="'ind_' + index"
                        v-bind:name="'ind[' + index + ']'"
                        ref="is_enabled"
                        v-model="field.checked"
                        />
                      <label
                      class="">{{ field.text }}</label>
                      </div>
                    </div>
                  </div>
                  <div class="col-6 float-left" style="padding-top: 0px;" >
                    <div v-for="(field, index) in ind_display_fields">
                      <div  v-if="index > 14">
                      <input
                        type="checkbox"
                        v-bind:id="'ind_' + index"
                        v-bind:name="'ind[' + index + ']'"
                        ref="is_enabled"
                        v-model="field.checked"
                        />
                      <label
                      class="">{{ field.text }}</label>
                      </div>
                    </div>
                  </div>
                </div>


              </div>
            </div>

          </div>
          </b-collapse>

        </div>
        <div style="clear: both;" class="margin-bottom-20"></div>
        <div class="col-12 override-padding">
            <button
                v-on:click="runReport()"
                class="btn btn-red btn-lg input-height-15"
                >Run Report</button>
            <button
                v-on:click="clearSearchAction()"
                class="btn btn-grey btn-lg input-height-15" style="margin-left: 15px;"
                >Clear Search</button>
            <button
                v-if="account_lists.length > 0"
                v-on:click="exportCSVAction()"
                class="btn btn-red btn-lg input-height-15 float-right"
                style="margin-left: 15px;"
                >Export CSV</button>

        </div>


          <div class="margin-bottom-10"></div>
          <div id="list-view">
          <div v-show="loading" class="loading_show"><div class="spinner-border text-danger"></div></div>
          <div v-if="listView" class="col-12 override-padding account-lookup-view-list" >
                  <div class="col-12 override-padding" style="padding-bottom: 5px; padding-top: 20px;" >
                    <h1 style="font-size: 27px;">List View</h1>
                  </div>
                    <div class="col-12 float-left override-padding pagination-wrapper" v-if="account_lists.length > 0">
                     <PaginationTop
                     ref="PaginationTop"
                     :currentPage="currentPage"
                     :totalRows="rows"
                     :perPage="perPage"
                     :showPaginatedFunction="showNaicsofPaginatedTop"
                     :showPerPageFunction="perPagePaginatedTop"
                     :totalPages="totalPages"
                     :sNo="sno"
                     >
                     </PaginationTop>
                    </div>
                <div class="row account_view_list_heading_row col-12" style="overflow: scroll;">
                  <table border="0" cellpadding="5" class="view-lists col-12">
                    <tr>
                      <th class="field_title">SI.NO</th>

                      <th class="field_title" style="padding-right: 5px;" v-for="(header, hindex) in headers">
                       <span v-if="header.sort == true">
                       <span class="bold cursor-pointer" v-on:click="sortMethod(header.alias)">
                       {{ header.heading }}
                       <span class="float-right padding-right-5 color-000">
                         <i v-if="sortField == header.alias && sortBy == 'ASC'" class="fa fa-sort-asc" aria-hidden="true"></i>
                         <i v-if="sortField == header.alias && sortBy == 'DESC'" class="fa fa-sort-desc" aria-hidden="true"></i>
                         <i v-if="sortField != header.alias" class="fa fa-sort" aria-hidden="true"></i>
                       </span>
                       </span>
                       </span>
                       <span class="bold" v-else>
                       {{ header.heading }}
                       </span>

                      </th>
                    </tr>
                    <tr v-for="(account_list, index) in account_lists" class="tasklist-row" v-if="account_lists.length > 0" v-on:click="router_redirect(account_list.accId, account_list.isEnterprise)">
                      <td>{{ sno + index + 1 }}</td>
                      <td v-for="(header) in headers">{{ getValue(account_list, header.alias) }}</td>
                    </tr>
                    <tr v-if="account_lists.length == 0">
                      <td :colspan="parseInt(headers.length + 1)">
                        No Accounts Found
                      </td>
                    </tr>
                  </table>
                 </div>


                    <div class="col-12 float-left override-padding pagination-wrapper" style="padding-bottom: 15px; padding-top: 15px;" v-if="account_lists.length > 0">
                     <Pagination
                     ref="Pagination"
                     :currentPage="currentPage"
                     :totalRows="rows"
                     :perPage="perPage"
                     :showPaginatedFunction="showNaicsofPaginated"
                     :showPerPageFunction="perPagePaginated"
                     :totalPages="totalPages"
                     :sNo="sno"
                     >
                     </Pagination>
                    </div>
           </div>
           </div>

           </div>
      <BatchModal :isModalVisible="isExportModalVisible" @close="isExportModalVisible = false">
        <span v-if="loading" class="pull-right text-danger">
          Loading...
        </span>
        <div slot="header" class="sub-heading"></div>
        <div slot="body">
          <div class="">
            <div class="export-details">
              Exported: {{ rowsExportedCSV }} of {{ rowsCSV}}
            </div>
            <div class="percentage-text">
              {{ percentage }}
            </div>
            <div class="batch-box">
              <div class="batch-loading" id="batch-loading" >
                &nbsp;
              </div>
            </div>
            <div class="download-link" @click="downloadFunc()" v-if="percentage == '100%'">
              Download CSV File
            </div>
          </div>
        </div>
        <div slot="footer" class="col-3 override-padding">

        </div>
      </BatchModal>







        </div>
      </div>
      </div>


   </div>


  </div>
</template>

<script>

import Vue from 'vue/dist/vue.esm';
import UserMenu from '../../shared/user_menu.vue';
import MasteradminSidebarMenu from '../../shared/masteradmin_sidebar_menu.vue';
import axios from 'axios';
import { store } from '../../../store/store';
import router from '../../../router/index.js';
import Pagination from '../../pagination.vue';
import PaginationTop from '../../pagination.vue';
import AccountReportFilter from './account_report_filter.vue';
import BatchModal from './report_loading_modal.vue';
import ResearcherSidebarMenu from '../../shared/researcher_sidebar_menu.vue';
import CSRSidebarMenu from '../../shared/csr_sidebar_menu.vue';

export default {
        data() {
          return {
            type: 'Account',
            org_display_fields: [],
            ind_display_fields: [],
            rows: 0,
            perPage: 100,
            currentPage: 1,
            loading: false,
            sortField: '',
            sortBy: '',
            searchParameters: {},
            sno: 0,
            pageOptions: [],
            totalPages: 0,
            totalCSVPages: 0,
            perCSVPage: 500,
            rowsCSV: 0,
            rowsExportedCSV: 0,
            account_lists: [],
            headers: [],
            listView: false,
            isExportModalVisible: false,
            percentage: '0%',
            fileName: '',
            apiUrl: '',
            researcher: false,
            masterAdmin: false,
            csr: false,
          }
        },

        components: {
          UserMenu,
          MasteradminSidebarMenu,
          Pagination,
          PaginationTop,
          AccountReportFilter,
          BatchModal,
          ResearcherSidebarMenu,
          CSRSidebarMenu,
        },

        methods: {
          getValue: function(accountList, key) {
            return accountList[key];
          },
          router_redirect: function(accountId, type) {
            if(type == false) {
              let routeData = this.$router.resolve({name: 'accountlookupdetail', params: {account_id: accountId}});
              window.open(routeData.href, '_blank');
            }
            else {
              let routeData = this.$router.resolve({name: 'enterpriselookupdetail', params: {account_id: accountId}});
              window.open(routeData.href, '_blank');
            }
            
          },
          downloadFunc: function() {
              var url = this.apiUrl + '/custom/csv-view/' + this.fileName + '/Account';
              window.location.href = url;
              this.isExportModalVisible = false;
              return false;
          },


          showNaicsofPaginated() {
            this.currentPage = this.$refs.Pagination.currentPageValue;
            this.$refs.PaginationTop.currentPageValue = this.currentPage;
            this.fetchAccountList();
          },
          perPagePaginated() {
            this.currentPage = 1;
            this.$refs.Pagination.currentPageValue = 1;
            this.perPage = this.$refs.Pagination.perPageValue;
            this.$refs.PaginationTop.perPageValue = this.perPage;
            this.$refs.PaginationTop.currentPageValue = 1;
            this.fetchAccountList();
          },
          showNaicsofPaginatedTop() {
            this.currentPage = this.$refs.PaginationTop.currentPageValue;
            this.$refs.Pagination.currentPageValue = this.currentPage;
            this.fetchAccountList();
          },
          perPagePaginatedTop() {
            this.currentPage = 1;
            this.$refs.PaginationTop.currentPageValue = 1;
            this.perPage = this.$refs.PaginationTop.perPageValue;
            this.$refs.Pagination.perPageValue = this.perPage;
            this.$refs.Pagination.currentPageValue = 1;
            this.fetchAccountList();
          },
          sortMethod: function(field) {
            this.sortField = field;
            if(this.sortBy == 'ASC') {
              this.sortBy = 'DESC';
            }
            else {
              this.sortBy = 'ASC';
            }
            if(this.listView == true) {
              this.$refs.PaginationTop.currentPageValue = 1;
              this.$refs.Pagination.currentPageValue = 1;
            }
            this.fetchAccountList();
          },
          runReport: function() {
            this.currentPage = 1;
            this.perPage = 100;
            this.sortField = '';
            this.sortBy = '';
            if((this.listView == true) && (this.account_lists.length > 0)) {
              this.$refs.PaginationTop.perPageValue = 100;
              this.$refs.Pagination.perPageValue = 100;
              this.$refs.PaginationTop.currentPageValue = 1;
              this.$refs.Pagination.currentPageValue = 1;
            }
            this.fetchAccountList();
          },
          fetchAccountList: function() {
            this.loading = true;
            this.searchParameters = {};
            this.searchParameters.lookup_type = this.$refs.AccountReportFilter.lookup_type;
            this.searchParameters.account_type = this.$refs.AccountReportFilter.account_type;
            this.searchParameters.program = this.$refs.AccountReportFilter.program;
            this.searchParameters.org_country = this.$refs.AccountReportFilter.org_country;
            this.searchParameters.org_state = this.$refs.AccountReportFilter.org_state;
            this.searchParameters.org_zip = this.$refs.AccountReportFilter.org_zip;
            this.searchParameters.org_market_area = this.$refs.AccountReportFilter.org_market_area;
            this.searchParameters.naics_id = this.$refs.AccountReportFilter.naics_id;
            this.searchParameters.naics_code = this.$refs.AccountReportFilter.naics_code;
            this.searchParameters.org_status = this.$refs.AccountReportFilter.org_status;
            this.searchParameters.updated_by = this.$refs.AccountReportFilter.updated_by;
            this.searchParameters.affiliate = this.$refs.AccountReportFilter.affiliate;

            this.searchParameters.admin_title = this.$refs.AccountReportFilter.title;
            this.searchParameters.country = this.$refs.AccountReportFilter.ind_country;
            this.searchParameters.zip = this.$refs.AccountReportFilter.ind_zip;
            this.searchParameters.state = this.$refs.AccountReportFilter.ind_state;
            this.searchParameters.status = this.$refs.AccountReportFilter.ind_status;
            this.searchParameters.roles = this.$refs.AccountReportFilter.roles;

            this.searchParameters.page = this.currentPage;
            this.searchParameters.perPage = this.perPage;

            this.searchParameters.sortField = this.sortField;
            this.searchParameters.sortBy = this.sortBy;

            var searchParam = this.search_parameters;
            axios("/account-report-lists", {
              method: 'POST',
              data: {
                search_parameters: this.searchParameters,
                org_display_fields: this.org_display_fields,
                ind_display_fields: this.ind_display_fields,
              }
            })
            .then(response => {
              this.loading = false;
              this.account_lists = response.data.data;
              this.headers = response.data.header;
              this.currentPage = response.data.page;
              if(this.currentPage > 1) {
                this.sno = this.perPage * (this.currentPage - 1);
              }
              else {
                this.sno = 0;
              }
              this.rows = response.data.total_rows;
              this.totalPages = response.data.total_pages;
              this.listView = true;

              this.$refs.PaginationTop.totalPagesValue = this.totalPages;
              this.$refs.Pagination.totalPagesValue = this.totalPages;
              this.$refs.PaginationTop.getPageOptions();
              this.$refs.Pagination.getPageOptions();
              
              const tabScroll = document.getElementById("list-view");
              window.scrollTo({
                'behavior': 'smooth',
                'left': 0,
                'top': tabScroll.offsetTop + 80
              });

              if(this.account_lists.length == 0) {
                this.flash({ message: "No accounts found.", variant: 'danger' });
                
                
              }
            })
            .catch(error => {

            });
          },
          exportCSVAction: function() {
            this.isExportModalVisible = false;
            this.currentCSVPage = 1;
            this.rowsCSV = 0;
            this.rowsExportedCSV = 0;
            this.totalCSVPages = 0;
            this.percentage = 0;
            this.fileName = '';
            this.fetchAccountListCSV();
          },
          fetchAccountListCSV: function() {
            this.searchParameters = {};
            this.searchParameters.lookup_type = this.$refs.AccountReportFilter.lookup_type;
            this.searchParameters.account_type = this.$refs.AccountReportFilter.account_type;
            this.searchParameters.program = this.$refs.AccountReportFilter.program;
            this.searchParameters.org_country = this.$refs.AccountReportFilter.org_country;
            this.searchParameters.org_state = this.$refs.AccountReportFilter.org_state;
            this.searchParameters.org_zip = this.$refs.AccountReportFilter.org_zip;
            this.searchParameters.org_market_area = this.$refs.AccountReportFilter.org_market_area;
            this.searchParameters.naics_id = this.$refs.AccountReportFilter.naics_id;
            this.searchParameters.naics_code = this.$refs.AccountReportFilter.naics_code;
            this.searchParameters.org_status = this.$refs.AccountReportFilter.org_status;
            this.searchParameters.updated_by = this.$refs.AccountReportFilter.updated_by;
            this.searchParameters.affiliate = this.$refs.AccountReportFilter.affiliate;

            this.searchParameters.admin_title = this.$refs.AccountReportFilter.title;
            this.searchParameters.country = this.$refs.AccountReportFilter.ind_country;
            this.searchParameters.zip = this.$refs.AccountReportFilter.ind_zip;
            this.searchParameters.state = this.$refs.AccountReportFilter.ind_state;
            this.searchParameters.status = this.$refs.AccountReportFilter.ind_status;
            this.searchParameters.roles = this.$refs.AccountReportFilter.roles;

            this.searchParameters.page = this.currentCSVPage;
            this.searchParameters.perPage = this.perCSVPage;
            this.searchParameters.fileName = this.fileName;

            this.searchParameters.sortField = this.sortField;
            this.searchParameters.sortBy = this.sortBy;

            var searchParam = this.search_parameters;
            axios("/account-report-lists-csv", {
              method: 'POST',
              data: {
                search_parameters: this.searchParameters,
                org_display_fields: this.org_display_fields,
                ind_display_fields: this.ind_display_fields,
              }
            })
            .then(response => {
              this.isExportModalVisible = true;
              this.currentCSVPage = response.data.page;
              this.rowsCSV = response.data.total_rows;
              this.rowsExportedCSV = response.data.total_rows_exported;
              this.totalCSVPages = response.data.total_pages;
              this.percentage = response.data.percentage;
              this.fileName = response.data.file_name;
              document.getElementById("batch-loading").style.width = this.percentage;
              if(this.currentCSVPage <= this.totalCSVPages) {
                this.fetchAccountListCSV();
              }
              
            })
            .catch(error => {

            });

          },
          getAccountReportDisplayFields: function() {
            axios('/account-report-display-fields',
             {
                method: 'GET',
             },
            )
            .then(response => {
                this.org_display_fields = response .data.orgDisplayFields;
                this.ind_display_fields = response.data.indDisplayFields;
             })
            .catch(error => {

            });

          },
          clearSearchAction: function(){
            this.account_lists = [];
            this.listView = false;
            this.$refs.AccountReportFilter.lookup_type = '';
            this.$refs.AccountReportFilter.account_type_options = [{ value: '', text: '-Any-' }];
            this.$refs.AccountReportFilter.account_type = '';
            this.$refs.AccountReportFilter.program = '';
            this.$refs.AccountReportFilter.org_country = '';
            this.$refs.AccountReportFilter.org_state = '';
            this.$refs.AccountReportFilter.state_options = [];
            this.$refs.AccountReportFilter.state_options = [{ value: '', text: '-Any-' }];
            this.$refs.AccountReportFilter.org_zip = '';
            this.$refs.AccountReportFilter.org_market_area = '';
            this.$refs.AccountReportFilter.naics_id = '';
            this.$refs.AccountReportFilter.naics_code = '';
            this.$refs.AccountReportFilter.org_status = '';
            this.$refs.AccountReportFilter.updated_by = '';
            this.$refs.AccountReportFilter.affiliate = '';

            this.$refs.AccountReportFilter.title = '';
            this.$refs.AccountReportFilter.ind_country = '';
            this.$refs.AccountReportFilter.ind_zip = '';
            this.$refs.AccountReportFilter.ind_state = '';
            this.$refs.AccountReportFilter.ind_state_options = [];
            this.$refs.AccountReportFilter.ind_state_options = [{ value: '', text: '-Any-' }];
            this.$refs.AccountReportFilter.ind_status = '';
            this.$refs.AccountReportFilter.roles = '';
            this.currentPage = 1;
            this.perPage = 100;
            if((this.listView == true) && (this.account_lists.length > 0)) {
              this.$refs.Pagination.currentPageValue = 1;
              this.$refs.PaginationTop.currentPageValue = 1;
              this.$refs.PaginationTop.perPageValue = 100;
              this.$refs.Pagination.perPageValue = 100;
            }

            this.getAccountReportDisplayFields();
          },
        },
        created() {
          this.listView = false;
          this.apiUrl = process.env.API_ENDPOINT;
          this.getAccountReportDisplayFields();
          var roles = this.$store.state.roles;
          if(roles.indexOf('ROLE_MASTER_ADMIN') > -1) {
            this.masterAdmin = true;
          }
          if(roles.indexOf('ROLE_RESEARCHER') > -1) {
            this.researcher = true;
          }
          if(roles.indexOf('ROLE_CSR') > -1) {
            this.csr = true;
          }
        },
}
</script>

<style scoped>
  label {
    padding-top: 8px;
  }
  .border-content {
    border: 1px solid #CCC;
    padding-top: 10px;
    border-top: 0;
  }
  .display_column_heading {
    background-color: #00ACEE;
    border: 1px solid #00ACEE;
    font-weight: bold;
    padding: 5px 20px;
    margin-top: 2px;
    color: #FFF;
  }
  .collapse-wrapper {
    background-color: #00ACEE;
    border: 1px solid #00ACEE;
    font-weight: bold;
    padding: 5px 10px;
    margin-top: 2px;
  }
  .collapse-wrapper a, .collapse-wrapper a:hover{ 
    color: #FFF;
    text-decoration: none;
    padding-top: 5px;
    display: inherit;
  }
  .collapse-wrapper i {
    float: right;
    font-size: 18px;
    font-weight: bold;
    padding-top: 0px;
    color: #FFF;
  }

</style>
<style scoped>
@import '../../../assets/styles/account_lookup.css';

.view-accountlist {
  min-height: 70vh;
}
.view-accountlist .tasklist-row:last-child{
  border-bottom: 1px solid #E5E5E5;
}
.account_view_list_heading_row {
  background: none;
}
tr th {
    /* background-color: #dc2227; */
    background-color: #00ACEE;
    line-height: 25px;
    color: #FFF;
    padding: 3px 0px;
    margin-right: 0px !important;
    margin-left: 0px !important;
}
tr td {
  color: #212529;
  cursor: pointer;
}
.account-lookup-view-list .field_title {
    width: auto;
    border-right: 1px solid #b6b6b6;
    padding-left: 5px;
    padding-right: 5px;
}
.view-lists {
  width: 100%;
}
.custom-select {
  height: 38px;
}
.report-dashboard-link {
  text-transform: uppercase;
}
.report-dashboard-link .fa-chevron-left {
  font-size: 13px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/reports/accounts_report.vue